@if (stepsLoading | async) {
  @if (!(flowError | async)) {
    <div class="main row">
      <div class="column twelve lg-push-two lg-eight">
        <ds-progress-indicator
          [steps]="steps | async"
          progressTitle="Claim Progress"
        ></ds-progress-indicator>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
}
